import React, { Component } from "react";
import { Input, Table, Button, Modal, Col, Row, message, Tooltip, Card, InputNumber, List, Menu, Dropdown, Icon } from "antd";
import InputForm from "../components/InputForm";
import "../components/Form.css";
import "./Pages.css";
import axios from "axios";
import VendaBalcaoForm from '../components/VendaBalcaoForm';
import PedidoPrintA4Modal from "../relatorios/PedidoPrintA4Modal";
import PedidoPrintCupomModal from "../relatorios/PedidoPrintCupomModal";
import ModalPadraoForm from '../components/ModalPadraoForm';
import moment from "moment-timezone";
import numeral from "numeral";
import Colors from '../utils/Colors';
import ProdutoFrame from '../components/ProdutoFrame';
import PessoaFrame from '../components/PessoaFrame';
import TipoDocFrame from '../components/TipoDocFrame';
import CondPagtoFrame from '../components/CondPagtoFrame';
import { getUsuario } from "../utils/LoginManager";
import Pedidos from '../tutoriais/LancPedidos';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    ven_idf: 0,
    ven_obs: '',
    ven_qtde_itens: 0,
    ven_vlr_itens: 0,
    ven_vlr_total: 0,
    totalFechado: 0,
    ven_pessoa: { key: '0' },
    ven_usuario: { key: '0' },
    ven_tipo_doc: { key: '0' },
    ven_cond_pagto: { key: '0' },
    ven_tipo_venda: { key: 'V' },

    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,

    listaRegistros: [],
    carregando: false,
    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,
    busca: '',
    idfVenda: 0,

    formProdutoVisivel: false,
    formPagtoVisivel: false,

    formPrintA4Visivel: false,
    formPrintCupomVisivel: false,

    modalReceberVisible: false,
    modalListaVisible: false,
    telaModal: '',

    mi_seq: 0,
    mi_item: { key: '0' },
    prod_codigo: '',
    prod_descricao: '',
    prod_cod_barras: '',
    mi_qtde: 1,
    mi_vlr_unit: 0,
    mi_vlr_venda: 0,
    mi_vlr_venda_min: 0,
    mi_perc_desc: 0,
    mi_vlr_desc: 0,
    mi_vlr_acres: 0,
    mi_vlr_total: 0,

    tit_valor: 0,

    listaProdutos: [],
    listaParcelas: [],
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
      listaProdutos: [],
    });
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, formProdutoVisivel: false, formPagtoVisivel: false, ven_idf: 0 });

    // console.log('getListaRegistros')

    axios
      .get('/vendas', {
        params: {
          campoOrdem: 'ven_obs',
          tipoOrdem: 'ASC',
          obs: this.state.busca,
          sitVen: 1,
          sitFin: 'A',
          dataIni: moment().format('YYYY-MM-DD'),
          dataFim: moment().format('YYYY-MM-DD'),
          print: 1,
        }
      })
      .then(response => {
        // console.log('getListaRegistros', response.data)

        if (response.data.dados.length === 1) {
          this.onEditarVendaClick(response.data.dados[0]);
        }

        this.setState({
          listaRegistros: response.data.dados,
          carregando: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };

  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };




  calculoTotalPedido = (listaProdutos) => {
    // console.log('calculoTotalPedido: ', listaProdutos);

    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].mi_qtde) * parseFloat(listaProdutos[x].mi_vlr_unit));
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    // console.log('calculoTotalPedido: ', qtdeItens);
    // console.log('calculoTotalPedido: ', vlrTotal);
    // console.log('calculoTotalPedido: ', listaProdutos);

    this.setState({
      ven_qtde_itens: qtdeItens,
      ven_vlr_itens: vlrItens,
      ven_vlr_desc: 0,
      ven_vlr_acres: 0,
      ven_vlr_total: vlrTotal,
    },
      this.forceUpdate()
    );
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };





  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFormIncluirProduto = (event) => {

    if ((!this.state.ven_obs) || (this.state.ven_obs === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe um Nome para o Pedido' });
      return;
    }
    if (!this.state.mi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }
    const vlrTotalAux = parseFloat(this.state.mi_vlr_total);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor do Produto' });
      return;
    }

    this.setState({
      salvando: true
    })

    this.state.listaProdutos.push({
      ven_idf: 0,
      venc_idf: 0,
      mi_idf_condicional: 0,
      mi_item: this.state.mi_item.pest_item,
      mi_seq: 0,
      prod_idf: this.state.mi_item.pest_item,
      pest_qtde: this.state.mi_item.pest_qtde,
      prod_grade: this.state.mi_item.prod_grade,
      mi_item_tamanho: this.state.mi_item.pest_tamanho,
      mi_item_cor: this.state.mi_item.pest_cor,
      ptam_descricao: this.state.mi_item.ptam_descricao,
      pcor_descricao: this.state.mi_item.pcor_descricao,
      prod_codigo: this.state.mi_item.cod,
      prod_descricao: this.state.mi_item.descr,
      prod_cod_barras: this.state.mi_item.prod_cod_barras,
      mi_qtde: parseFloat(this.state.mi_qtde),
      mi_vlr_unit: parseFloat(this.state.mi_vlr_unit),
      mi_vlr_venda: this.state.mi_vlr_venda,
      mi_vlr_venda_min: this.state.mi_vlr_venda_min,
      mi_perc_desc: 0,
      mi_vlr_desc: 0,
      mi_vlr_acres: 0,
      mi_vlr_total: parseFloat(this.state.mi_vlr_total),
    });

    let vlrTotal = 0;
    for (var x in this.state.listaProdutos) {
      vlrTotal = vlrTotal + (parseFloat(this.state.listaProdutos[x].mi_qtde) * parseFloat(this.state.listaProdutos[x].mi_vlr_unit));
    }

    const registro = {
      ven_pessoa: this.state.ven_pessoa.key ? this.state.ven_pessoa.key : this.state.usuario.par_cliente,
      ven_vlr_itens: vlrTotal,
      ven_vlr_total: vlrTotal,
      ven_obs: this.state.ven_obs,
      listaProdutos: this.state.listaProdutos
    };


    let request;
    if (this.state.ven_idf) {
      request = axios.put(`/vendas/update/${this.state.ven_idf}`, registro);
    } else {
      request = axios.post(`/vendas/store`, registro)
    }
    request
      .then(response => {
        // console.log('onFormIncluirProduto', response)

        message.success('Pedido gravado com sucesso');

        const { listaRegistros } = this.state;

        if (!this.state.editando) {
          listaRegistros.unshift({
            ven_idf: response.data.idf,
            ven_obs: this.state.ven_obs,
            ven_vlr_itens: vlrTotal,
            ven_vlr_total: vlrTotal,
          });
          this.setState({
            listaRegistros,
            editando: true,
          }, this.onEditarVendaClick({ ven_idf: response.data.idf }))

        } else {
          let iIndItem = -1;
          for (var x in this.state.listaRegistros) {
            if (String(this.state.listaRegistros[x].ven_idf) === String(this.state.ven_idf)) {
              iIndItem = x;
            }
          }
          if (iIndItem >= 0) {
            listaRegistros[iIndItem].ven_obs = this.state.ven_obs;
            listaRegistros[iIndItem].ven_vlr_itens = parseFloat(vlrTotal);
            listaRegistros[iIndItem].ven_vlr_total = parseFloat(vlrTotal);
          }
          this.setState({
            listaRegistros,
            editando: true,
          }, this.onEditarVendaClick({ ven_idf: response.data.idf }))
        }

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onNovoClick = () => {
    this.setState({
      ven_idf: 0,
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_total: 0,
      totalFechado: 0,
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_tipo_doc: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_tipo_venda: { key: 'V' },

      formProdutoVisivel: true,
      formPagtoVisivel: false,
      carregandoForm: false,
      editando: false,
      visualizando: false,
      caixaFechado: false,

      modalReceberVisible: false,
      modalListaVisible: false,
      telaModal: '',
      busca: '',
      listaProdutos: [],
      listaParcelas: [],
    });
  }

  onEditarVendaClick = (reg) => {
    // console.log('onEditarVendaClick', reg)

    if (reg.ven_idf === this.state.ven_idf) {
      this.setState({
        ven_idf: 0,
        formProdutoVisivel: false,
        formPagtoVisivel: false,
      })
    } else {
      this.setState({ carregando: true });
      axios.get(`/vendas/show/${reg.ven_idf}`)
        .then(response => {
          const { data } = response;

          let vlrParc = 0;
          for (var x in data.listaParcelas) {
            vlrParc = vlrParc + parseFloat(data.listaParcelas[x].tparc_valor);
          }

          this.setState({
            ...data.dados,
            ...data,
            totalFechado: vlrParc,

            ven_pessoa: {
              key: data.dados.ven_pessoa ? String(data.dados.ven_pessoa) : this.state.usuario.par_cliente ? String(this.state.usuario.par_cliente) : '0',
              label: data.dados.pes_nome ? data.dados.pes_nome : this.state.usuario.pes_nome_cli ? this.state.usuario.pes_nome_cli : '',
            },

            formProdutoVisivel: true,
            formPagtoVisivel: false,
            editando: true,
            carregando: false,
          })
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            carregando: false,
          })
        })
    }
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/vendas/deleteItem/${this.state.ven_idf}/${reg.mi_idf}`)
          .then(response => {

            const { listaRegistros } = this.state;
            const listaProdutos = [...this.state.listaProdutos];
            const index = listaProdutos.findIndex(registro => registro.prod_idf === reg.prod_idf);
            listaProdutos.splice(index, 1);

            let vlrTotal = 0;
            for (var x in listaProdutos) {
              vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
            }

            let iIndItem = -1;
            for (var x in this.state.listaRegistros) {
              if (String(this.state.listaRegistros[x].ven_idf) === String(this.state.ven_idf)) {
                iIndItem = x;
              }
            }
            if (iIndItem >= 0) {
              listaRegistros[iIndItem].ven_vlr_itens = parseFloat(vlrTotal);
              listaRegistros[iIndItem].ven_vlr_total = parseFloat(vlrTotal);
            }
            this.setState({
              listaRegistros,
              editando: true,
            }, this.onEditarVendaClick({ ven_idf: this.state.ven_idf }))

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  }


  renderPedidos = (lista) => {
    const content = lista.map(regList =>
      <Col xs={24} sm={12} md={8} lg={6} xl={4} style={{ padding: 5 }}>
        <div style={{ margin: 0, padding: 8, height: 90, backgroundColor: regList.ven_idf === this.state.ven_idf ? Colors.primaryLight : Colors.primary, boxShadow: '2px 2px 5px 0px' }}>
          <a onClick={() => this.onEditarVendaClick(regList)} style={{ color: Colors.textSecondaryDark }}>
            <Row style={{ fontSize: 20, color: Colors.textPrimaryLight }}>
              <span style={{ fontWeight: 'bold' }}>
                {regList.ven_obs}
              </span>
            </Row>
            <Row style={{ marginTop: 0, fontSize: 15, color: Colors.textSecondaryLight }}>
              <div style={{ fontWeight: 'bold' }}>
                Total: {this.renderValor(regList.ven_vlr_total)}
              </div>
              {regList.totalFechado ? (
                <div style={{ fontWeight: 'bold', color: regList.ven_idf === this.state.ven_idf ? Colors.textSecondaryDark : '#6EFD00FF' }}>
                  {/* <div style={{ fontWeight: 'bold', color: '#04006AFF' }}> */}
                  À Receber: {this.renderValor(parseFloat(parseFloat(regList.ven_vlr_total).toFixed(2)) - parseFloat(parseFloat(regList.totalFechado).toFixed(2)))}
                </div>
              ) : null}
            </Row>
          </a>
        </div>
      </Col>
    );
    return (
      <Row type="flex" justify="start" style={{ backgroundColor: Colors.fundoPage, padding: 5 }}>
        {content}
      </Row>
    );
  };

  renderProdutos = () => {
    return (
      <List
        itemLayout="horizontal"
        dataSource={this.state.listaProdutos}
        renderItem={item => (
          <List.Item key={item.id} style={{ paddingTop: 5, paddingBottom: 5 }}>
            <Tooltip title="Excluir" placement="topLeft">
              <List.Item.Meta
                title={<a onClick={() => (this.onExcluirProdutosClick(item))} style={{ underline: { textDecorationLine: 'underline' } }}>{item.prod_descricao}</a>}
              // description={item.valor}
              />
            </Tooltip>
            <div style={{ marginRight: 12 }}>Qtde: {item.mi_qtde}</div>
            <div>Vlr: {this.renderValor(item.mi_vlr_total)}</div>
          </List.Item>
        )}
      >
      </List>
    );
  };






  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };




  onChangeProduto = event => {
    // console.log('onChangeProduto: ', event);
    this.state.mi_item = event.mi_item;
    this.state.mi_vlr_unit = parseFloat(event.mi_item.vlrVenda);
    this.state.mi_perc_desc = 0;
    this.state.mi_vlr_desc = 0;
    this.setState(event);

    const { mi_qtde, mi_perc_desc, mi_vlr_desc } = this.state;
    this.calculoItem(mi_qtde, parseFloat(event.mi_item.vlrVenda), mi_perc_desc, mi_vlr_desc);
  }

  onInputChangeQtde = event => {
    this.setState({ mi_qtde: event });
    const { mi_vlr_unit, mi_perc_desc, mi_vlr_desc } = this.state;
    this.calculoItem(event, mi_vlr_unit, mi_perc_desc, mi_vlr_desc);
  }


  calculoItem = (mi_qtde, mi_vlr_unit, mi_perc_desc, mi_vlr_desc) => {
    const vlrUnit = mi_vlr_unit ? parseFloat(mi_vlr_unit) : 0;
    const qtde = mi_qtde ? parseFloat(mi_qtde) : 0;
    let percDesc = percDesc ? parseFloat(mi_perc_desc) : 0;
    let vlrDesc = mi_vlr_desc ? parseFloat(mi_vlr_desc) : 0;

    if (vlrDesc === 0) {
      percDesc = mi_perc_desc ? (parseFloat(mi_perc_desc) / 100) : 0;
      vlrDesc = parseFloat((parseFloat(mi_qtde) * parseFloat(vlrUnit)) * percDesc);
    }

    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    this.setState({
      mi_vlr_total: vlrTotal,
      mi_vlr_desc: vlrDesc,
    });
  }


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  onFecharModalLista = () => {
    this.setState({
      modalReceberVisible: false,
      modalListaVisible: false,
      telaModal: '',
    }, this.getListaRegistros());
  }


  onReceberClick = () => {
    // console.log('onReceberClick: ', this.state);

    if ((this.state.listaProdutos) && (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na venda', });
      return;
    }

    this.state.ven_pessoa = {
      key: this.state.ven_pessoa.key ? String(this.state.ven_pessoa.key) : this.state.usuario.par_cliente ? String(this.state.usuario.par_cliente) : '0',
      label: this.state.ven_pessoa.label ? this.state.ven_pessoa.label : this.state.usuario.pes_nome_cli ? this.state.usuario.pes_nome_cli : '',
    };

    this.setState({
      formProdutoVisivel: false,
      formPagtoVisivel: true,
      tit_valor: this.state.totalFechado ? (parseFloat(this.state.ven_vlr_total) - parseFloat(this.state.totalFechado)) : this.state.ven_vlr_total,
      ven_pessoa: {
        key: this.state.ven_pessoa.key ? String(this.state.ven_pessoa.key) : this.state.usuario.par_cliente ? String(this.state.usuario.par_cliente) : '0',
        label: this.state.ven_pessoa.label ? this.state.ven_pessoa.label : this.state.usuario.pes_nome_cli ? this.state.usuario.pes_nome_cli : '',
      },
      ven_tipo_doc: {
        key: String(this.state.usuario.par_doc_padrao),
        label: this.state.usuario.td_descricao,
      },
      ven_cond_pagto: {
        key: String(this.state.usuario.par_cond_pagto_padrao),
        label: this.state.usuario.td_descricao,
        qtdeParc: this.state.usuario.cp_qtde_parc,
        parcAVista: this.state.usuario.cp_parc_avista,
      },
    }, this.forceUpdate);

  }

  onSalvarClick = () => {
    if ((!this.state.ven_pessoa) || (this.state.ven_pessoa.key === '0') || (this.state.ven_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.ven_tipo_doc) || (this.state.ven_tipo_doc.key === '0') || (this.state.ven_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }
    if ((!this.state.ven_cond_pagto) || (this.state.ven_cond_pagto.key === '0') || (this.state.ven_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento' });
      return;
    }
    const vlrTotalAux = parseFloat(this.state.tit_valor);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor do Pagamento' });
      return;
    }


    this.setState({ salvando: true });

    const reg = {
      ven_obs: this.state.ven_obs,
      ven_vlr_total: this.state.ven_vlr_total,
      tit_valor: this.state.tit_valor,
      ven_pessoa: this.state.ven_pessoa.key,
      ven_tipo_doc: this.state.ven_tipo_doc.key,
      ven_cond_pagto: this.state.ven_cond_pagto.key,
    }

    axios.put(`/vendas/fecharPedido/${this.state.ven_idf}`, reg)
      .then(response => {

        this.getListaRegistros();

        this.setState({
          formProdutoVisivel: false,
          formPagtoVisivel: false,
          salvando: false,
        })

        // if (this.state.usuario.par_impr_venda_balcao === 'COM') {
        //   this.onImprimirA4Click(response.data.idf);
        // } else if (this.state.usuario.par_impr_venda_balcao === 'CUP') {
        //   this.onImprimirCupomClick(response.data.idf);
        // }
        message.success('Pedido Fianlizado com sucesso');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if ((error.response.status) && (error.response.status === 412)) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onChangePessoa = event => {
    this.state.ven_pessoa = event.ven_pessoa;
    this.setState(event);
  }

  onChangeTipoDoc = event => {
    this.state.ven_tipo_doc = event.ven_tipo_doc;
    this.setState(event);
  }

  onChangeCondPagto = event => {
    this.state.ven_cond_pagto = event.ven_cond_pagto;
    this.setState(event);
  }





  onImprimirA4Click = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintA4Visivel: true,
    });
  };

  onImprimirCupomClick = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintCupomVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfVenda: 0,
      formPrintA4Visivel: false,
      formPrintCupomVisivel: false
    })
  }


  onClientesClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'clientes',
    });
  }

  onFichaFinancClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'fichaFinanc',
    });
  }

  onCtasPagarRecClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'ctasPagarRec',
    });
  }

  onResumoCaixaClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'resumoCaixa',
    });
  }

  onListaVendasClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'vendas',
    });
  }


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------






  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { modalReceberVisible, modalListaVisible,
      telaModal, listaRegistros, registroSelecionado, formPrintA4Visivel, formPrintCupomVisivel, formProdutoVisivel, formPagtoVisivel,
      mi_item, mi_qtde, mi_vlr_total, ven_idf, ven_obs, ven_vlr_total, ven_pessoa, ven_tipo_doc, ven_cond_pagto, tit_valor,
      innerWidth, innerHeight
    } = this.state;

    // console.log('VendaBalcaoPage.this.state: ', this.state);

    var windowHeight = window.innerHeight;

    return (
      <div style={{ padding: 10, backgroundColor: Colors.fundoPage, height: windowHeight - 80 }}>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Col xs={2} style={{ backgroundColor: Colors.fundoPage, paddingTop: 10, paddingBottom: 10 }}>
            <Dropdown overlay={
              <Menu>
                <Menu.Item>
                  <a onClick={() => this.onResumoCaixaClick()}>
                    Extrato do Caixa
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.onListaVendasClick()}>
                    Vendas Realizadas
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.onCtasPagarRecClick()}>
                    Contas à Pagar/Receber
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.onFichaFinancClick()}>
                    Ficha Financeira
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.onClientesClick()}>
                    Cadastro de Clientes
                  </a>
                </Menu.Item>
              </Menu>
            } placement="bottomLeft">
              <Icon type="bars" style={{ fontSize: 35, marginTop: 8, marginLeft: 10, float: 'center' }} />
            </Dropdown>
          </Col>
          <Col xs={21} style={{ backgroundColor: Colors.fundoPage, paddingTop: 10, paddingBottom: 10 }}>
            <span className="tituloPage">
              PEDIDOS
            </span>
          </Col>
          <Col xs={1} style={{ backgroundColor: Colors.fundoPage, paddingTop: 10, paddingBottom: 10 }}>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </Col>
        </div>

        <div className="divider-page" />

        <VendaBalcaoForm
          visivel={modalReceberVisible}
          registroSelecionado={registroSelecionado}
          onFecharClick={this.onFecharModalLista}
          onSalvarClick={this.onSalvarClick}
        />

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={telaModal}
          valorTotal={ven_vlr_total}
          onFecharClick={this.onFecharModalLista}
        />

        <PedidoPrintA4Modal
          visivel={formPrintA4Visivel}
          ven_idf={this.state.idfVenda}
          tipoVenda="V"
          onCancelarPrintClick={this.onCancelarPrintClick}
        />

        <PedidoPrintCupomModal
          visivel={formPrintCupomVisivel}
          ven_idf={this.state.idfVenda}
          tipoVenda="V"
          onCancelarPrintClick={this.onCancelarPrintClick}
        />

        <Pedidos
          isOpen={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
        />


        {/* ------------------------------ */}
        {/* PAINEL CABEÇALHO               */}
        {/* ------------------------------ */}
        <Row type="flex" style={{ width: "100%", backgroundColor: Colors.fundoPage, border: '1px solid #e8e8e8' }}>
          <Col xs={24} lg={6} style={{ padding: 10 }}>
            <Search
              placeholder="Buscar Pedido"
              enterButton
              allowClear
              onSearch={this.onBuscar}
              className="pageFiltro-busca"
            />
          </Col>
          <Col xs={24} lg={4} xl={4} xxl={2} style={{ padding: 10 }}>
            <Tooltip title="Novo Pedido" placement="topRight">
              <Button
                type="primary"
                icon="plus"
                htmlType="button"
                onClick={() => this.onNovoClick()}
                style={{ width: "100%", height: 32 }}
                className="botao-primary"
              >
                Novo
              </Button>
            </Tooltip>
          </Col>
        </Row>


        {/* ------------------------------ */}
        {/* PAINEL BODY                    */}
        {/* ------------------------------ */}
        <Row style={{ width: "100%", marginBottom: 5, border: '1px solid #e8e8e8' }}>



          {/* ------------------------------ */}
          {/* PAINEL PEDIDOS                 */}
          {/* ------------------------------ */}
          <Col xs={24} xl={formProdutoVisivel || formPagtoVisivel ? 18 : 24} style={{ backgroundColor: Colors.fundoPage }}>
            {listaRegistros ? this.renderPedidos(listaRegistros) : null}
          </Col>



          {/* ------------------------------ */}
          {/* PAINEL TOTAIS                  */}
          {/* ------------------------------ */}
          {formProdutoVisivel ? (
            <Col xs={24} xl={6} style={{}}>
              <div style={{ width: "100%", padding: 8, marginBottom: 5, backgroundColor: Colors.fundoPage, border: '1px solid #e8e8e8' }}>

                <Row style={{ padding: 10, backgroundColor: Colors.primaryLight, borderRadius: 4 }}>
                  <Col xs={10} style={{ marginTop: 5 }}>
                    <span style={{ fontSize: 30, fontWeight: "bold", color: Colors.textPrimaryLight }}>Pedido</span>
                  </Col>
                  <Col xs={14} style={{ marginBottom: -30 }}>
                    <InputForm
                      type="text"
                      id="ven_obs"
                      ref="ven_obs"
                      value={ven_obs}
                      placeholder="Nome"
                      style={{ fontSize: 30, fontWeight: 'bold', height: 50, color: Colors.textSecondaryDark }}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>

                <Row style={{ paddingLeft: 5, paddingRight: 5, marginTop: 10 }}>
                  <ProdutoFrame
                    label="Produto"
                    id="mi_item"
                    value={mi_item}
                    width={"100%"}
                    style={{}}
                    onChange={this.onChangeProduto}
                  />
                </Row>

                <Row style={{}}>
                  <Col xs={24} sm={12} style={{ padding: 5, marginTop: -30 }}>
                    <span style={{ fontSize: 13 }}>Qtde</span>
                    <InputNumber
                      ref="Input"
                      id={mi_qtde}
                      value={mi_qtde}
                      onChange={this.onInputChangeQtde}
                      min={1}
                      max={999}
                      maxLength={6}
                      style={{ width: '100%', marginTop: 3 }}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ padding: 5, marginTop: innerWidth < 768 ? -10 : -30, marginBottom: -25 }}>
                    <span style={{ fontSize: 13 }}>Total</span>
                    <InputForm
                      type="number"
                      id="mi_vlr_total"
                      ref="mi_vlr_total"
                      value={mi_vlr_total}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <div>
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Adicionar Produto" placement="topRight">
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={() => this.onFormIncluirProduto()}
                        style={{ width: "100%" }}
                        className="botao-primary"
                      >
                        Adicionar
                      </Button>
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Fechar Pedido" placement="topRight">
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={() => this.onReceberClick()}
                        style={{ width: "100%" }}
                        className="botao-primary"
                      >
                        Fechar
                      </Button>
                    </Tooltip>
                  </Col>
                </div>


                <div style={{ height: windowHeight - 540, overflowY: 'auto', padding: 3 }}>
                  <div className="divider-page" />
                  {this.renderProdutos()}
                </div>


                <div style={{ width: "100%", height: 65, padding: 2, marginBottom: 1, backgroundColor: Colors.background }}>
                  <div style={{ width: "100%", height: 60, padding: 2, backgroundColor: Colors.fundoPage }}>
                    <div style={{ width: "100%", height: "100%", backgroundColor: Colors.primaryLight, padding: 3 }}>
                      <div style={{ textAlign: "center" }}>
                        <div>
                          <span style={{ fontSize: 15, fontWeight: "bold", color: Colors.textPrimaryLight }}>Valor Total</span>
                        </div>
                        <div style={{}}>
                          <span style={{ fontSize: 20, fontWeight: "bold", color: Colors.textPrimaryLight }}>{this.renderValor(ven_vlr_total)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div >
            </Col >
          ) : null}



          {/* ------------------------------ */}
          {/* PAINEL PAGTO                   */}
          {/* ------------------------------ */}
          {formPagtoVisivel ? (
            <Col xs={24} xl={6} style={{}}>
              <div style={{ width: "100%", padding: 8, marginBottom: 5, backgroundColor: Colors.fundoPage, border: '1px solid #e8e8e8' }}>

                <Row style={{ padding: 10, backgroundColor: Colors.primaryLight, borderRadius: 4 }}>
                  <Col xs={10} style={{ marginTop: 5 }}>
                    <span style={{ fontSize: 30, fontWeight: "bold", color: Colors.textPrimaryLight }}>Pedido</span>
                  </Col>
                  <Col xs={14} style={{ marginBottom: -30 }}>
                    <InputForm
                      type="text"
                      id="ven_obs"
                      ref="ven_obs"
                      value={ven_obs}
                      placeholder="Nome"
                      style={{ fontSize: 30, fontWeight: 'bold', height: 50, color: Colors.textSecondaryDark }}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>

                <Row style={{ padding: 5, marginTop: 30 }}>
                  <PessoaFrame
                    label="Cliente"
                    id="ven_pessoa"
                    value={ven_pessoa}
                    tipo="C"
                    width={"100%"}
                    onChange={this.onChangePessoa}
                  />
                </Row>

                <Row style={{}}>
                  <Col xs={24} sm={12} style={{ padding: 5, marginTop: -25 }}>
                    <TipoDocFrame
                      label="Tipo Documento"
                      id="ven_tipo_doc"
                      value={ven_tipo_doc}
                      width={"100%"}
                      onChange={this.onChangeTipoDoc}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ padding: 5, marginTop: -25 }}>
                    <CondPagtoFrame
                      label="Condição de Pagamento"
                      id="ven_cond_pagto"
                      value={ven_cond_pagto}
                      width={"100%"}
                      onChange={this.onChangeCondPagto}
                    />
                  </Col>
                </Row>

                <Row style={{ padding: 5 }}>
                  <Col xs={24} style={{ marginTop: -30 }}>
                    <span style={{ fontSize: 13 }}>Valor Pagamento</span>
                    <InputForm
                      type="number"
                      id="tit_valor"
                      ref="tit_valor"
                      value={tit_valor}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => (this.setState({
                        formProdutoVisivel: true,
                        formPagtoVisivel: false,
                      }))}
                      style={{ width: "100%" }}
                      className="botao-primary"
                    >
                      Voltar
                    </Button>
                  </Col>
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => this.onSalvarClick()}
                      style={{ width: "100%" }}
                      className="botao-primary"
                    >
                      Pagar
                    </Button>
                  </Col>
                </Row>

              </div >
            </Col >
          ) : null}


        </Row >

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PedidosPage.js